import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import { Branch, KnowledgeGraphApi } from './KnowledgeGraphApi';

export class KnowledgeGraphClient implements KnowledgeGraphApi {
  private readonly fetchApi: FetchApi;
  private readonly discoveryApi: DiscoveryApi;

  constructor(opts: { fetchApi: FetchApi; discoveryApi: DiscoveryApi }) {
    this.fetchApi = opts.fetchApi;
    this.discoveryApi = opts.discoveryApi;
  }

  async getViewerUrl(
    repo: string,
    path: string,
    ref: string,
  ): Promise<string> {
    const baseUrl = await this.discoveryApi.getBaseUrl('knowledge-graph');
    const params = new URLSearchParams({ repo, path, ref });
    return `${baseUrl}/viewer/?${params.toString()}`;
  }

  async getBranches(repo: string): Promise<Branch[]> {
    const baseUrl = await this.discoveryApi.getBaseUrl('knowledge-graph');
    const response = await this.fetchApi.fetch(
      `${baseUrl}/branches?repo=${encodeURIComponent(repo)}`,
    );

    if (!response.ok) {
      return [];
    }

    return response.json() as Promise<Branch[]>;
  }

  async getPaths(repo: string, ref: string): Promise<string[]> {
    const baseUrl = await this.discoveryApi.getBaseUrl('knowledge-graph');
    const params = new URLSearchParams({ repo, ref });
    const response = await this.fetchApi.fetch(
      `${baseUrl}/paths?${params.toString()}`,
    );

    if (!response.ok) {
      return [];
    }

    return response.json() as Promise<string[]>;
  }
}
